import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadLeads = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      width: "40px",
      align: "left",
    },
    {
      title: "Nome",
      align: "left",
      width: "250px",
      minWidth: "250px",
    },
    {
      title: "Ids do cliente",
      align: "left",
      width: "250px",
      minWidth: "250px",
    },
    {
      title: "Whats/Telefone",
      align: "left",
      width: "100px",
      minWidth: "100px",
    },
    {
      title: "Data de criação",
      align: "right",
      width: "140px",
      minWidth: "140px",
    },
    {
      title: "Último login",
      align: "right",
      width: "120px",
      minWidth: "120px",
    },
    {
      title: "Status",
      align: "center",
      width: "100px",
      minWidth: "100px",
    },
    {
      title: "Data final teste",
      align: "right",
      width: "140px",
      minWidth: "140px",
    },
    {
      title: "Iniciou pagamento",
      align: "center",
      width: "140px",
      minWidth: "140px",
    },
    {
      title: "Início pagamento",
      align: "right",
      width: "140px",
      minWidth: "140px",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
